export enum ToBackendRequestInfoNameEnum {
  // check
  ToBackendCheck = 'api/ToBackendCheck',
  ToBackendCheckSignUp = 'api/ToBackendCheckSignUp',
  // telemetry
  ToBackendTelemetryLogs = 'api/ToBackendTelemetryLogs',
  ToBackendTelemetryMetrics = 'api/ToBackendTelemetryMetrics',
  ToBackendTelemetryTraces = 'api/ToBackendTelemetryTraces',
  // special
  ToBackendSpecialRebuildStructs = 'api/ToBackendSpecialRebuildStructs',
  // test-routes
  ToBackendGetRebuildStruct = 'api/ToBackendGetRebuildStruct',
  ToBackendSeedRecords = 'api/ToBackendSeedRecords',
  ToBackendDeleteRecords = 'api/ToBackendDeleteRecords',
  ToBackendCloneTestRepo = 'api/ToBackendCloneTestRepo',
  //
  ToBackendCompleteUserRegistration = 'api/ToBackendCompleteUserRegistration',
  ToBackendConfirmUserEmail = 'api/ToBackendConfirmUserEmail',
  ToBackendDeleteUser = 'api/ToBackendDeleteUser',
  ToBackendDeleteUserApiKey = 'api/ToBackendDeleteUserApiKey',
  ToBackendGenerateUserApiKey = 'api/ToBackendGenerateUserApiKey',
  ToBackendGetUserGivens = 'api/ToBackendGetUserGivens',
  ToBackendGetUserProfile = 'api/ToBackendGetUserProfile',
  ToBackendLoginUser = 'api/ToBackendLoginUser',
  ToBackendLogoutUser = 'api/ToBackendLogoutUser',
  ToBackendRegisterUser = 'api/ToBackendRegisterUser',
  ToBackendResendUserEmail = 'api/ToBackendResendUserEmail',
  ToBackendResetUserPassword = 'api/ToBackendResetUserPassword',
  ToBackendSetUserName = 'api/ToBackendSetUserName',
  ToBackendSetUserUi = 'api/ToBackendSetUserUi',
  ToBackendUpdateUserPassword = 'api/ToBackendUpdateUserPassword',
  ToBackendStartUserCodexAuth = 'api/ToBackendStartUserCodexAuth',
  ToBackendPollUserCodexAuth = 'api/ToBackendPollUserCodexAuth',
  ToBackendDeleteUserCodexAuth = 'api/ToBackendDeleteUserCodexAuth',
  ToBackendGetServerUsers = 'api/ToBackendGetServerUsers',
  //
  ToBackendCreateOrg = 'api/ToBackendCreateOrg',
  ToBackendGetOrgsList = 'api/ToBackendGetOrgsList',
  ToBackendGetOrg = 'api/ToBackendGetOrg',
  ToBackendIsOrgExist = 'api/ToBackendIsOrgExist',
  ToBackendSetOrgInfo = 'api/ToBackendSetOrgInfo',
  ToBackendSetOrgOwner = 'api/ToBackendSetOrgOwner',
  ToBackendDeleteOrg = 'api/ToBackendDeleteOrg',
  //
  ToBackendGenerateProjectRemoteKey = 'api/ToBackendGenerateProjectRemoteKey',
  ToBackendCreateProject = 'api/ToBackendCreateProject',
  ToBackendIsProjectExist = 'api/ToBackendIsProjectExist',
  ToBackendGetProject = 'api/ToBackendGetProject',
  ToBackendSetProjectTimezone = 'api/ToBackendSetProjectTimezone',
  ToBackendSetProjectWeekStart = 'api/ToBackendSetProjectWeekStart',
  ToBackendSetProjectAllowTimezones = 'api/ToBackendSetProjectAllowTimezones',
  ToBackendGetProjectsList = 'api/ToBackendGetProjectsList',
  ToBackendDeleteProject = 'api/ToBackendDeleteProject',
  ToBackendSetProjectInfo = 'api/ToBackendSetProjectInfo',
  ToBackendSetProjectSandboxProvider = 'api/ToBackendSetProjectSandboxProvider',
  //
  ToBackendGetEnvsList = 'api/ToBackendGetEnvsList',
  ToBackendGetEnvs = 'api/ToBackendGetEnvs',
  ToBackendCreateEnv = 'api/ToBackendCreateEnv',
  ToBackendCreateEnvUser = 'api/ToBackendCreateEnvUser',
  ToBackendCreateEnvVar = 'api/ToBackendCreateEnvVar',
  ToBackendDeleteEnv = 'api/ToBackendDeleteEnv',
  ToBackendDeleteEnvUser = 'api/ToBackendDeleteEnvUser',
  ToBackendDeleteEnvVar = 'api/ToBackendDeleteEnvVar',
  ToBackendEditEnvVar = 'api/ToBackendEditEnvVar',
  ToBackendEditEnvFallbacks = 'api/ToBackendEditEnvFallbacks',
  //
  ToBackendGetGivens = 'api/ToBackendGetGivens',
  ToBackendCreateGiven = 'api/ToBackendCreateGiven',
  ToBackendDeleteGiven = 'api/ToBackendDeleteGiven',
  ToBackendEditGiven = 'api/ToBackendEditGiven',
  //
  ToBackendGetRoles = 'api/ToBackendGetRoles',
  ToBackendCreateRole = 'api/ToBackendCreateRole',
  ToBackendCreateRoleGiven = 'api/ToBackendCreateRoleGiven',
  ToBackendEditRoleGiven = 'api/ToBackendEditRoleGiven',
  ToBackendDeleteRoleGiven = 'api/ToBackendDeleteRoleGiven',
  ToBackendDeleteRole = 'api/ToBackendDeleteRole',
  //
  ToBackendGetMembers = 'api/ToBackendGetMembers',
  ToBackendGetMemberGivens = 'api/ToBackendGetMemberGivens',
  ToBackendGetMembersList = 'api/ToBackendGetMembersList',
  ToBackendCreateMember = 'api/ToBackendCreateMember',
  ToBackendEditMember = 'api/ToBackendEditMember',
  ToBackendDeleteMember = 'api/ToBackendDeleteMember',
  //
  ToBackendGetOrgUsers = 'api/ToBackendGetOrgUsers',
  //
  ToBackendGetConnections = 'api/ToBackendGetConnections',
  ToBackendCreateConnection = 'api/ToBackendCreateConnection',
  ToBackendDeleteConnection = 'api/ToBackendDeleteConnection',
  ToBackendEditConnection = 'api/ToBackendEditConnection',
  ToBackendTestConnection = 'api/ToBackendTestConnection',
  ToBackendGetConnectionSchemas = 'api/ToBackendGetConnectionSchemas',
  ToBackendGetConnectionSample = 'api/ToBackendGetConnectionSample',
  ToBackendGetCachedColumns = 'api/ToBackendGetCachedColumns',
  ToBackendViewCachedColumn = 'api/ToBackendViewCachedColumn',
  ToBackendRefreshCachedColumn = 'api/ToBackendRefreshCachedColumn',
  ToBackendClearCachedColumn = 'api/ToBackendClearCachedColumn',
  ToBackendGetConnectionsList = 'api/ToBackendGetConnectionsList',
  //
  ToBackendCreateProvider = 'api/ToBackendCreateProvider',
  ToBackendGetProviders = 'api/ToBackendGetProviders',
  ToBackendGetLlmModelParts = 'api/ToBackendGetLlmModelParts',
  ToBackendGetLlmModelsWithProvider = 'api/ToBackendGetLlmModelsWithProvider',
  ToBackendEditProvider = 'api/ToBackendEditProvider',
  ToBackendDeleteProvider = 'api/ToBackendDeleteProvider',
  ToBackendToggleProvider = 'api/ToBackendToggleProvider',
  ToBackendCreateLlmModel = 'api/ToBackendCreateLlmModel',
  ToBackendEditLlmModel = 'api/ToBackendEditLlmModel',
  ToBackendDeleteLlmModel = 'api/ToBackendDeleteLlmModel',
  //
  ToBackendGetBranchesList = 'api/ToBackendGetBranchesList',
  ToBackendIsBranchExist = 'api/ToBackendIsBranchExist',
  ToBackendCreateBranch = 'api/ToBackendCreateBranch',
  ToBackendDeleteBranch = 'api/ToBackendDeleteBranch',
  //
  ToBackendGetRepo = 'api/ToBackendGetRepo',
  ToBackendCommitRepo = 'api/ToBackendCommitRepo',
  ToBackendPushRepo = 'api/ToBackendPushRepo',
  ToBackendPullRepo = 'api/ToBackendPullRepo',
  ToBackendRevertRepoToLastCommit = 'api/ToBackendRevertRepoToLastCommit',
  ToBackendRevertRepoToRemote = 'api/ToBackendRevertRepoToRemote',
  ToBackendMergeRepo = 'api/ToBackendMergeRepo',
  ToBackendSyncRepo = 'api/ToBackendSyncRepo',
  //
  ToBackendGetQueryInfo = 'api/ToBackendGetQueryInfo',
  //
  ToBackendRun = 'api/ToBackendRun',
  //
  ToBackendGetState = 'api/ToBackendGetState',
  //
  ToBackendGetStruct = 'api/ToBackendGetStruct',
  //
  ToBackendMoveCatalogNode = 'api/ToBackendMoveCatalogNode',
  ToBackendRenameCatalogNode = 'api/ToBackendRenameCatalogNode',
  //
  ToBackendCreateFolder = 'api/ToBackendCreateFolder',
  ToBackendDeleteFolder = 'api/ToBackendDeleteFolder',
  //
  ToBackendGetFile = 'api/ToBackendGetFile',
  ToBackendCreateFile = 'api/ToBackendCreateFile',
  ToBackendDeleteFile = 'api/ToBackendDeleteFile',
  ToBackendSaveFile = 'api/ToBackendSaveFile',
  ToBackendValidateFiles = 'api/ToBackendValidateFiles',
  //
  ToBackendGetSuggestFields = 'api/ToBackendGetSuggestFields',
  //
  ToBackendSetFavorite = 'api/ToBackendSetFavorite',
  //
  ToBackendGetModels = 'api/ToBackendGetModels',
  ToBackendGetModel = 'api/ToBackendGetModel',
  //
  ToBackendCreateDraftChart = 'api/ToBackendCreateDraftChart',
  ToBackendDeleteChart = 'api/ToBackendDeleteChart',
  ToBackendDeleteDraftCharts = 'api/ToBackendDeleteDraftCharts',
  ToBackendEditDraftChart = 'api/ToBackendEditDraftChart',
  ToBackendGetChart = 'api/ToBackendGetChart',
  ToBackendGetCharts = 'api/ToBackendGetCharts',
  ToBackendSaveCreateChart = 'api/ToBackendSaveCreateChart',
  ToBackendSaveModifyChart = 'api/ToBackendSaveModifyChart',
  //
  ToBackendCreateDraftDashboard = 'api/ToBackendCreateDraftDashboard',
  ToBackendDeleteDashboard = 'api/ToBackendDeleteDashboard',
  ToBackendDeleteDraftDashboards = 'api/ToBackendDeleteDraftDashboards',
  ToBackendEditDraftDashboard = 'api/ToBackendEditDraftDashboard',
  ToBackendGetDashboard = 'api/ToBackendGetDashboard',
  ToBackendGetDashboards = 'api/ToBackendGetDashboards',
  ToBackendSaveCreateDashboard = 'api/ToBackendSaveCreateDashboard',
  ToBackendSaveModifyDashboard = 'api/ToBackendSaveModifyDashboard',
  //
  ToBackendCreateDraftReport = 'api/ToBackendCreateDraftReport',
  ToBackendDeleteDraftReports = 'api/ToBackendDeleteDraftReports',
  ToBackendDeleteReport = 'api/ToBackendDeleteReport',
  ToBackendEditDraftReport = 'api/ToBackendEditDraftReport',
  ToBackendGetReport = 'api/ToBackendGetReport',
  ToBackendGetReports = 'api/ToBackendGetReports',
  ToBackendSaveCreateReport = 'api/ToBackendSaveCreateReport',
  ToBackendSaveModifyReport = 'api/ToBackendSaveModifyReport',
  //
  ToBackendDuplicateMconfigAndQuery = 'api/ToBackendDuplicateMconfigAndQuery',
  ToBackendGroupMetricByDimension = 'api/ToBackendGroupMetricByDimension',
  ToBackendSuggestDimensionValues = 'api/ToBackendSuggestDimensionValues',
  //
  ToBackendGetQueries = 'api/ToBackendGetQueries',
  ToBackendGetQuery = 'api/ToBackendGetQuery',
  ToBackendRunQueries = 'api/ToBackendRunQueries',
  ToBackendRunQueriesDry = 'api/ToBackendRunQueriesDry',
  ToBackendCancelQueries = 'api/ToBackendCancelQueries',
  //
  ToBackendCheckLastNav = 'api/ToBackendCheckLastNav',
  ToBackendGetNav = 'api/ToBackendGetNav',
  //
  ToBackendGetAvatarBig = 'api/ToBackendGetAvatarBig',
  ToBackendSetAvatar = 'api/ToBackendSetAvatar',
  //
  ToBackendArchiveSession = 'api/ToBackendArchiveSession',
  ToBackendCreateEditorSession = 'api/ToBackendCreateEditorSession',
  ToBackendCreateExplorerSession = 'api/ToBackendCreateExplorerSession',
  ToBackendCreateSessionSseTicket = 'api/ToBackendCreateSessionSseTicket',
  ToBackendDeleteSession = 'api/ToBackendDeleteSession',
  ToBackendGetSession = 'api/ToBackendGetSession',
  ToBackendGetSessionsList = 'api/ToBackendGetSessionsList',
  ToBackendPauseEditorSession = 'api/ToBackendPauseEditorSession',
  ToBackendSendMessageToEditorSession = 'api/ToBackendSendMessageToEditorSession',
  ToBackendSendMessageToExplorerSession = 'api/ToBackendSendMessageToExplorerSession',
  ToBackendCloseExplorerSessionTab = 'api/ToBackendCloseExplorerSessionTab',
  ToBackendSetSessionTitle = 'api/ToBackendSetSessionTitle',
  //
  ToBackendProduceExplorerChart = 'api/ToBackendProduceExplorerChart',
  ToBackendGetExplorerChartTab = 'api/ToBackendGetExplorerChartTab',
  //
  ToBackendGetSkills = 'api/ToBackendGetSkills'
}
